define('widgets/paymentMethodList/viewmodel',['knockout', 'underscore'], function (ko, _) {

    var PaymentMethodList = function() {};

    PaymentMethodList.prototype.activate = function(settings) {
        this.chooseMethodTextGenerator = settings.chooseMethodTextGenerator || _.identity;
        this.savedMethods = settings.savedMethods || ko.observableArray([]);
        this.availableMethods = settings.availableMethods || ko.observableArray([]);
        this.selectedMethod = settings.selectedMethod || ko.observable();
        this.onSelect = settings.onSelect || function() {};
        this.onCreate = settings.onCreate || function() {};
    };

    PaymentMethodList.prototype.isSelected = function(method) {
        var self = this;
        return ko.deferredComputed(function () {

            if (!self.selectedMethod()) {
                return false;
            }
            else if (_.includes(self.savedMethods(), self.selectedMethod())) {
                return method === self.selectedMethod();
            } else {
                return method.name() === self.selectedMethod().specificMethod().name();
            }
        });
    };

    PaymentMethodList.prototype.selectMethod = function(method) {
        this.selectedMethod(method);
        this.onSelect(method);
    };

    PaymentMethodList.prototype.createNewMethod = function(method) {
        this.onCreate(method);
    };

    return PaymentMethodList;
});


